import { io } from 'socket.io-client';
import { getStoredAccessToken } from './meetingAuth';
import { getMeetingSocketBaseUrl } from './meetingSocketUrl';

let dashboardSocket = null;

export const getMeetingDashboardSocket = () => {
  const token = getStoredAccessToken();

  if (!dashboardSocket) {
    dashboardSocket = io(getMeetingSocketBaseUrl(), {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      withCredentials: true,
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 750,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      auth: { token },
    });
  } else {
    dashboardSocket.auth = { token };
  }

  if (!dashboardSocket.connected) dashboardSocket.connect();
  window.socket = dashboardSocket;
  return dashboardSocket;
};

export const refreshMeetingDashboardSocketAuth = () => {
  if (!dashboardSocket) return getMeetingDashboardSocket();
  dashboardSocket.auth = { token: getStoredAccessToken() };
  if (dashboardSocket.connected) {
    dashboardSocket.disconnect().connect();
  } else {
    dashboardSocket.connect();
  }
  return dashboardSocket;
};

export const disconnectMeetingDashboardSocket = () => {
  if (!dashboardSocket) return;
  dashboardSocket.removeAllListeners();
  dashboardSocket.disconnect();
  dashboardSocket = null;
  window.socket = null;
};

